import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';

import FillSurveyPage from '../../components/pages/fillSurveyPage';
import { fillSurveySelector } from '../../store/selectors/fillSurveySelector';
import { useTranslations } from '../../utility/useTranslations';
import {
  getFillSurvey,
  clearFillSurvey,
  getSurveyReview,
  setAttributeAnswerResult,
  setQuestionnaireAnswerResult,
  setAnswerTextResult,
  setAnswerCommentResult,
  setReviewStep,
  setComments,
  submitReview,
  setIsInlineSurvey,
} from '../../store/modules/fillSurvey';
import {
  EVENT_ACTION_TYPES,
  tagManagerDataLayer,
} from '../../utility/tagManager';
import { APP_PAGES } from '../../constants/pages';

const mapStateToProps = state => ({
  ...fillSurveySelector(state),
});

const mapDispatchToProps = dispatch => ({
  getFillSurvey: token => getFillSurvey(dispatch, token),
  getSurveyReview: (token, reviewId, isQuestionnaire = false) =>
    getSurveyReview(dispatch, token, reviewId, isQuestionnaire),
  setAttributeAnswerResult: (token, answer, shouldReset) =>
    setAttributeAnswerResult(dispatch, token, answer, shouldReset),
  setQuestionnaireAnswerResult: (token, answer) =>
    setQuestionnaireAnswerResult(dispatch, token, answer),
  setAnswerTextResult: (token, answer) =>
    setAnswerTextResult(dispatch, token, answer),
  setAnswerCommentResult: (token, answer) =>
    setAnswerCommentResult(dispatch, token, answer),
  setReviewStep: step => dispatch(setReviewStep(step)),
  setComments: comments => dispatch(setComments(comments)),
  submitReview: (token, comments) => submitReview(dispatch, token, comments),
  clearFillSurvey: isInline => dispatch(clearFillSurvey(isInline)),
  setIsInlineSurvey: isInline => dispatch(setIsInlineSurvey(isInline)),
});

const FillSurveyPageView = ({ getFillSurvey: getSurvey, ...rest }) => {
  const navigate = useNavigate();
  const { token } = useParams();
  const translations = useTranslations(APP_PAGES.FILL_SURVEY);

  useEffect(() => {
    const { VisitFSP } = EVENT_ACTION_TYPES;
    if (token) {
      getSurvey(token);
      tagManagerDataLayer(VisitFSP.action, VisitFSP.name);
    } else {
      throw new Error('Survey token is not available!');
    }
  }, [token, getSurvey]);

  return (
    <FillSurveyPage
      {...rest}
      navigate={navigate}
      trackingToken={token}
      translations={translations}
    />
  );
};

FillSurveyPageView.propTypes = {
  getFillSurvey: PropTypes.func.isRequired,
  clearFillSurvey: PropTypes.func.isRequired,
  isInlineSurvey: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FillSurveyPageView);
